module.exports = __webpack_public_path__ + "img/2-2.b14d8c7b.png";